import { useField, useFormikContext } from 'formik';

import styled from '@emotion/styled';

import {
  FieldErrorInfo,
  IInputField,
  Input,
  InputContainer,
  InputLabel,
  InputWrapper,
} from './FormField';

export const CurrencyOnlyInputField: React.FC<
  IInputField & { maxLength?: number; showErrorLabel?: boolean }
> = ({
  label,
  lpiSrc,
  rpiSrc,
  className,
  maxLength,
  showErrorLabel = true,
  onValueChange,
  readonly = false,
  ...props
}) => {
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext<any>();

  // Format number with thousand separators
  const formatMoney = (value: string | number): string => {
    if (!value) return '';
    const numStr = value.toString().replace(/,/g, '');
    return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  // Remove formatting to get raw number
  const unFormatMoney = (value: string): string => {
    return value.replace(/,/g, '');
  };

  const handleChange = (e: any) => {
    const { value } = e.target;
    const rawValue = unFormatMoney(value);

    if (/^\d*$/.test(rawValue)) {
      // Check if maxLength is specified and enforce the limit
      if (maxLength && rawValue.length > maxLength) {
        return; // Don't update if exceeding max length
      }
      setFieldValue(props.name, rawValue);
      if (onValueChange) {
        onValueChange(rawValue, props.name);
      }
    } else if (rawValue === '') {
      setFieldValue(props.name, '');
      if (onValueChange) {
        onValueChange('', props.name);
      }
    }
  };

  return (
    <InputWrapper className={className}>
      <WrappedInputLabel htmlFor={props.name || props.id}>
        {label}
      </WrappedInputLabel>
      <InputContainer>
        <WrappedInput
          {...field}
          {...props}
          readOnly={readonly}
          value={formatMoney(field?.value ?? '')}
          onChange={(e) => handleChange(e)}
          padding='10px 40px'
        />
        <CurrencyIcon>₦</CurrencyIcon>
      </InputContainer>
      {showErrorLabel && meta.touched && meta.error ? (
        <FieldErrorInfo>{meta.error.capitalize()}</FieldErrorInfo>
      ) : null}
    </InputWrapper>
  );
};

export default CurrencyOnlyInputField;

const CurrencyIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: auto;
  margin-left: 16px;
  color: #5b91f5;
  /* border: 1px solid red; */
`;

const WrappedInputLabel = styled(InputLabel)`
  color: #6b7280;
  font-weight: 600;
  font-size: 12px;
`;

const WrappedInput = styled(Input)`
  color: #6e7079;
  font-weight: 600;

  &::placeholder {
    font-weight: 600;
  }
`;
